export const signIn = (credentials) => {
    return (dispatch, getState, { getFirebase }) => {
        const firebase = getFirebase();

        firebase.auth().signInWithEmailAndPassword(
            credentials.email,
            credentials.password
        ).then(() => {
            dispatch({ type: 'LOGIN_SUCCESS' })
        }).catch((err) => {
            dispatch({ type: 'LOGIN_ERROR', err })
        });
    }
}

export const signOut = () => {
    return (dispatch, getState, { getFirebase }) => {
        const firebase = getFirebase();

        firebase.auth().signOut()
        .then(() => {
            dispatch({ type: 'SIGNOUT_SUCCESS' });
        });
    }
}

export const signUp = (newUser) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        const firebase = getFirebase();
        const firestore = getFirestore();

        firebase.auth().createUserWithEmailAndPassword(
            newUser.email,
            newUser.password
        )
        .then((resp) => {
            return firestore.collection('users').doc(resp.user.uid).set({
                email: newUser.email,
                companyName: newUser.companyName,
                companyDescription: newUser.companyDescription,
                ceoNAME: newUser.ceoNAME,
                noOfEmpl: newUser.noOfEmpl,
                website: newUser.website,
                twitter: newUser.twitter,
                linkedin: newUser.linkedin,
                facebook: newUser.facebook,
                phone: newUser.phone,
                avatarURL: newUser.avatarURL,
                initials: newUser.companyName[0] + newUser.companyName[1]
            })
        })
        .then(() => {
            dispatch({ type: 'SIGNUP_SUCCESS' })
        })
        .catch(err => {
            dispatch({ type: 'SIGNUP_ERROR', err })
        })
    }
}


export const uploadImg = (user) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        const firestore = getFirestore();
        const authorId = getState().firebase.auth.uid;        
        const userDetails = getState().firebase.profile;        

        firestore.collection('users').doc(authorId).set({
                ...userDetails,
                avatarURL: user.avatarURL
        })
        .then(() => {
            dispatch({ type: 'UPLOAD_SUCCESS' })
        })
        .catch(err => {
            dispatch({ type: 'UPLOAD_ERROR', err })
        })
    }
}